(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
const yotpoWidget = document.querySelector('.yotpo-widget-instance');
const reviewsAccordion = document.querySelector('[data-accordion="reviews"]');

if (yotpoWidget && reviewsAccordion) {
  let observer;

  const hasVisibleContent = (element) => {
    return Array.from(element.childNodes).some(
      (node) => node.nodeType === Node.ELEMENT_NODE || 
                (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0)
    );
  };

  const toggleAccordion = () => {
    const hasContent = hasVisibleContent(yotpoWidget);
    reviewsAccordion.style.display = hasContent ? 'block' : 'none';
    if (hasContent && observer) {
      observer.disconnect();
      observer = null;
    }
  };

  toggleAccordion();

  if (!hasVisibleContent(yotpoWidget)) {
    observer = new MutationObserver(toggleAccordion);
    observer.observe(yotpoWidget, { childList: true, subtree: true });
  }
}

  } catch(e) { console.error(e); }
})();
})();
